export const MAY = 4

// Evaluated lazily (not at module load) so tests that stub Date.now in beforeAll
// see the stubbed value, and so the value stays correct if a long-lived session
// crosses July 1.
export const relevantYear = () => {
  const today = new Date(Date.now())
  return today.getMonth() > MAY ? today.getUTCFullYear() : today.getUTCFullYear() - 1
}
